module.exports = __webpack_public_path__ + "media/images/athletes/4340-3651516a8ac6455ef1bfb544ec64c689.png";